import script from "./OptSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./OptSlider.vue?vue&type=script&setup=true&lang=js"

import "./OptSlider.vue?vue&type=style&index=0&id=3b20c0f1&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b20c0f1"]])

export default __exports__